/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import Blades from "components/common/Blades";
import { modifyDocumentTitle } from "components/utils";
import Ajv from "ajv";
import schema from "components/modify/JsonEditorSchema";
import JsonEditor from "components/modify/JsonEditor";
import {
  getEditableEventAction,
  setEditableEventAction,
  createEventAction,
  getAllUsersAction,
} from "store/actions";
import ChangeEditors from "components/modify/ChangeEditors";
import DefaultMission from "components/modify/DefaultMission";
import { emptyMission } from "components/modify/default-missions/emptyMission";
import Preview from "components/modify/Preview";
import Save from "components/modify/Save";
import {
  removeChildrenProperty,
  readdChildrenProperty,
  getUsername,
} from "utils";

//sets the default mission state to the empty mission
function getDefaultMissionState(username) {
  return emptyMission({ username }).schema;
}

//sets the default mission description state
function getDefaultMissionDescription(username) {
  return emptyMission({ username }).description;
}

const CreatePage = ({
  getAllValidMissionMakers,
  validMissionMakers,
  username,
  createEvent,
}) => {
  //default mission tab state, denoting which one is selected
  const [defaultMissionSelection, setDefaultMissionSelection] =
    useState("emptyMission");

  //default mission tab state, denoting which one is selected
  const [defaultMissionDescription, setDefaultMissionDescription] = useState(
    getDefaultMissionDescription(username)
  );

  //actual mission data that will be sent to api
  const [mission, setMission]: any = useState(
    removeChildrenProperty(getDefaultMissionState(username))
  );

  //List of editors, is concatted to mission above when saving
  //default is admin and the user making the mission
  const [editors, setEditors] = useState(["administrator", username]);

  function setMissionToState(mission) {
    setMission(removeChildrenProperty(mission));
  }

  //Set title
  useEffect(() => {
    modifyDocumentTitle("Create Mission");
  }, []);

  //fetches all possible users that can be editors
  useEffect(() => {
    getAllValidMissionMakers();
  }, []);

  //initialise schema validator
  const ajv = new Ajv({ allErrors: true, verbose: true });

  const content = [
    {
      component: (
        <DefaultMission
          setMission={setMission}
          defaultMissionSelection={defaultMissionSelection}
          setDefaultMissionSelection={setDefaultMissionSelection}
          defaultMissionDescription={defaultMissionDescription}
          setDefaultMissionDescription={setDefaultMissionDescription}
          username={username}
        />
      ),
      title: "DEFAULT_MISSION",
    },
    {
      component: (
        <JsonEditor
          event={mission}
          saveEvent={setMissionToState}
          ajv={ajv}
          schema={schema}
          defaultMissionSelection={defaultMissionSelection}
        />
      ),
      title: "SCHEMA_TREE",
    },
    {
      component: (
        <JsonEditor
          event={mission}
          saveEvent={setMissionToState}
          ajv={ajv}
          schema={schema}
          defaultMissionSelection={defaultMissionSelection}
          mode={"text"}
        />
      ),
      title: "SCHEMA_CODE",
    },
    {
      component: <Preview event={readdChildrenProperty(mission)} />,
      title: "PREVIEW",
    },
    {
      component: (
        <ChangeEditors
          validMissionMakers={validMissionMakers}
          editors={editors}
          setEditors={setEditors}
          username={username}
        />
      ),
      title: "EDITORS",
    },
    {
      component: (
        <Save
          mission={mission}
          ajv={ajv}
          createEvent={createEvent}
          editors={editors}
          confirmationModalText={
            <div>
              Are you sure you want to publish?
              <p>You can always edit this mission later.</p>
            </div>
          }
        />
      ),
      title: "SAVE",
    },
  ];

  return <Blades content={content} />;
};

const mapStateToProps = (state) => ({
  validMissionMakers: get(state, "rootReducer.core.users.userList", []).map(
    (i) => i.username
  ),
  username: getUsername(),
});

const mapDispatchToProps = {
  getEditableEvent: getEditableEventAction,
  setEditableEvent: setEditableEventAction,
  createEvent: createEventAction,
  getAllValidMissionMakers: getAllUsersAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePage);
